import {
  Box,
  Button,
  Grid,
  IconButton,
  MenuItem,
  Modal,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useCallback, useEffect, useState } from "react";
import { useAlert } from "../../../../../Contexts/AlertContext/AlertService";
import { useLoading } from "../../../../../providers/loadingProvider";
import { useNotify } from "../../../../../providers/NotificationProvider";
import { finalRecommendations } from "../../../Constants";
import service from "../../../Helpers/gifservices";
import CancelIcon from "@mui/icons-material/Cancel";
import { useConfirm } from "../../../../../Contexts/ConfirmContext/ConfirmService";


const evaluationAndRecommendationTip = `Please write a short summary bassed on the referees' evaluations and your professional opinion, along with your recommendation for funding for the Board of Governors. If you recommend this proposal for funding, please also comment on the requested budget`;
const myGradingTip = `Your mark here`;
const theProposalRankingTip = `Rank this proposal in comparison to all the proposals assigned to you`;

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: "40%",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #000",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `15%`,
    left: `30%`,
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
  },
  miniTitle: {
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 5,
  },
  infoIcon: {
    marginLeft: 5,
  },
  select: {
    width: "70%",
  },
  saveButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
  },
  button: {
    marginLeft: 10,
  },
  closeIcon: {
    top: -20,
    left: -30,
    marginBottom:-50,
  },
}));

export default function AdvisorGradeModal(props) {
  const classes = useStyles();
  const loading = useLoading();
  const alert = useAlert();
  const confirm = useConfirm();
  const notify = useNotify();
  const {
    open,
    onClose,
    totalProposalsNumber,
    proposalAdvisor,
    refreshProposals,
    readOnly,
  } = props;
  const [comments, setComments] = useState("");
  const [recommend, setRecommend] = useState(``);
  const [rank, setRank] = useState(``);
  const [rankingOptions, setRankingOptions] = useState([]);

  const submitEvaluation = async () => {
    const res = await confirm({
      title: "Confirm Submit Evaluation",
      description: "Are you sure you want to submit the evaluation? Note!! changes cant be made after submiting!" ,
    });
    if (!res) return;
    const loadingId = loading.addLoading("Submiting Evaluation");
    const proposalAdvisorId = proposalAdvisor.id;
    var result = await service.UpdateAdvisorRanking({
      proposalAdvisorId,
      rank,
      grade: recommend,
      comment: comments,
      isFinal:true
    });
    loading.removeLoading(loadingId);
    if (!result) {
      await alert({
        title: "Error Submiting Evaluation",
        description: `Sorry there was a problem in submiting the evaluation`,
      });
    } else {
      onClose();
      notify.show("Submiting evaluation completed successfully");
      refreshProposals();
    }
  };

  const draftEvaluation = async () => {
    const proposalAdvisorId = proposalAdvisor.id;
    onClose();
    var result = await service.UpdateAdvisorRanking({
      proposalAdvisorId,
      rank,
      grade: recommend,
      comment: comments,
      isFinal:false
    });
    if (!result) {
      await alert({
        title: "Error draft Evaluation",
        description: `Sorry there was a problem in draft the evaluation`,
      });
    } else {
      notify.show("Draft evaluation completed successfully");
      refreshProposals();
    }
  };

  const buildRanking = useCallback(async() => {
    if (!open) return;
    let rankingArray = [];
    for (let i = 1; i <= totalProposalsNumber; i++)
      rankingArray.push(`${i}/${totalProposalsNumber}`);
    setRankingOptions(rankingArray);
  }, [totalProposalsNumber, open]);

  useEffect(() => {
    buildRanking();
  }, [buildRanking]);

  useEffect(() => {
    if (!proposalAdvisor) return;
    if (!recommend && proposalAdvisor.advisorRecommend)
      setRecommend(proposalAdvisor.advisorRecommend);
    if (!rank && proposalAdvisor.advisorRanking)
      setRank(proposalAdvisor.advisorRanking);
    if (!comments && proposalAdvisor.comments)
      setComments(proposalAdvisor.comments || "");
  }, [comments, proposalAdvisor, rank, recommend]);

  return (
    <Modal open={open} onClose={onClose}>
      <Paper className={classes.paper}>
        <Grid container>
        <IconButton className={classes.closeIcon} onClick={onClose} size="large">
                <CancelIcon  style={{fontSize:30}}/>
              </IconButton>
          <Box width="100%" marginBottom={3} textAlign="center">
            <Typography className={classes.title}>
              Advisor Evaluation
            </Typography>
          </Box>
          <Grid item xs={12}>
            <Box display="flex" marginTop={2}>
              <Typography className={classes.miniTitle}>
                My Evaluation and Recommendations
              </Typography>
              <Tooltip title={evaluationAndRecommendationTip}>
                <InfoOutlinedIcon
                  className={classes.infoIcon}
                  color="primary"
                />
              </Tooltip>
            </Box>
            <TextField
              label="Evaluation & Recommendations"
              fullWidth
              multiline
              maxRows={10}
              rows={6}
              value={comments}
              disabled={readOnly}
              onChange={(e) => setComments(e.target.value)}
            ></TextField>
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" marginTop={5}>
              <Typography className={classes.miniTitle}>My Grading</Typography>
              <Tooltip title={myGradingTip}>
                <InfoOutlinedIcon
                  className={classes.infoIcon}
                  color="primary"
                />
              </Tooltip>
            </Box>
            <Select
              className={classes.select}
              value={recommend}
              onChange={(e) => setRecommend(e.target.value)}
              disabled={readOnly}
            >
              {finalRecommendations.map((recommend) => (
                <MenuItem key={recommend.value} value={recommend.value}>
                  {recommend.label}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" marginTop={5}>
              <Typography className={classes.miniTitle}>
                The Proposal Ranking
              </Typography>
              <Tooltip title={theProposalRankingTip}>
                <InfoOutlinedIcon
                  className={classes.infoIcon}
                  color="primary"
                />
              </Tooltip>
            </Box>
            <Select
              className={classes.select}
              value={rank}
              onChange={(e) => setRank(e.target.value)}
              disabled={readOnly}
            >
              {rankingOptions.map((rank, index) => (
                <MenuItem key={rank} value={index + 1}>
                  {rank}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
        {!readOnly && (
          <Box style={{ float: "right" }} marginTop={3}>
            <Button
              disableElevation
              variant="contained"
              className={classes.saveButton}
              onClick={submitEvaluation}
            >
              Submit Evaluation
            </Button>
            <Button
              disableElevation
              variant="contained"
              className={classes.button}
              onClick={draftEvaluation}
            >
              Save Draft
            </Button>
          </Box>
        )}
      </Paper>
    </Modal>
  );
}
